export const HELP_CENTER_MENU_ITEM_TYPE = {
  RAPORT_ISSUE: 'report-issue'
} as const;
